var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card-title',{staticClass:"justify-center"},[_vm._v(" Registration Complete ")]),_c('v-card-text',[_c('sweetalert-icon',{attrs:{"icon":"success"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }